/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateAwsIamCredentialForm,
  CreateAwsIamCredentialForm$Outbound,
  CreateAwsIamCredentialForm$outboundSchema,
} from "../components/createawsiamcredentialform.js";

export type CreateAwsIamCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateAwsIamCredentialRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createAwsIamCredentialForm: CreateAwsIamCredentialForm;
};

/** @internal */
export type CreateAwsIamCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateAwsIamCredentialSecurity$outboundSchema: z.ZodMiniType<
  CreateAwsIamCredentialSecurity$Outbound,
  CreateAwsIamCredentialSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createAwsIamCredentialSecurityToJSON(
  createAwsIamCredentialSecurity: CreateAwsIamCredentialSecurity,
): string {
  return JSON.stringify(
    CreateAwsIamCredentialSecurity$outboundSchema.parse(
      createAwsIamCredentialSecurity,
    ),
  );
}

/** @internal */
export type CreateAwsIamCredentialRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateAwsIamCredentialForm: CreateAwsIamCredentialForm$Outbound;
};

/** @internal */
export const CreateAwsIamCredentialRequest$outboundSchema: z.ZodMiniType<
  CreateAwsIamCredentialRequest$Outbound,
  CreateAwsIamCredentialRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    createAwsIamCredentialForm: CreateAwsIamCredentialForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      createAwsIamCredentialForm: "CreateAwsIamCredentialForm",
    });
  }),
);

export function createAwsIamCredentialRequestToJSON(
  createAwsIamCredentialRequest: CreateAwsIamCredentialRequest,
): string {
  return JSON.stringify(
    CreateAwsIamCredentialRequest$outboundSchema.parse(
      createAwsIamCredentialRequest,
    ),
  );
}
